import { useQuery, useMutation } from "@apollo/client";
import {
  ORGANIZATION_CHALLENGES,
  CREATE_CHALLENGE,
  UPDATE_CHALLENGE,
  PUBLISH_CHALLENGE,
  STOP_CHALLENGE_RECURRENCE,
} from "../graphql";
import type { OrganizationChallengesResult, ChallengeStatus } from "../types";

// ─── Queries ─────────────────────────────────────────────────────────────────

interface UseOrganizationChallengesOptions {
  organizationId: string;
  status?: ChallengeStatus;
  limit?: number;
  offset?: number;
}

export function useOrganizationChallenges(
  options: UseOrganizationChallengesOptions,
) {
  const { organizationId, status, limit = 50, offset = 0 } = options;
  return useQuery<{
    organizationChallenges: OrganizationChallengesResult;
  }>(ORGANIZATION_CHALLENGES, {
    variables: {
      organizationId,
      ...(status ? { status } : {}),
      limit,
      offset,
    },
    fetchPolicy: "cache-and-network",
    skip: !organizationId,
  });
}

// ─── Mutations ───────────────────────────────────────────────────────────────

export function useCreateChallenge() {
  return useMutation(CREATE_CHALLENGE, {
    refetchQueries: ["OrganizationChallenges"],
  });
}

export function useUpdateChallenge() {
  return useMutation(UPDATE_CHALLENGE, {
    refetchQueries: ["OrganizationChallenges"],
  });
}

export function usePublishChallenge() {
  return useMutation(PUBLISH_CHALLENGE, {
    refetchQueries: ["OrganizationChallenges"],
  });
}

export function useStopChallengeRecurrence() {
  return useMutation(STOP_CHALLENGE_RECURRENCE, {
    refetchQueries: ["OrganizationChallenges"],
  });
}
